<template>
  <b-container>
    <base-error-container :modelstate="modelstate"></base-error-container>

    <!-- <div>{{model}}</div> -->
    <base-row-detail
      label="Id"
      :value="`${this.model.cargoId}`"
    ></base-row-detail>

    <!-- CargoTypeId -->
    <base-row-detail
      :label="$t('tracking.cargo.cargoType')"
      :value="`${this.cargoTypeDescription}`"
    ></base-row-detail>

    <!-- ClientDocumentType -->
    <base-row-detail
      :label="$t('tracking.cargo.clientDocumentType')"
      :value="this.model.clientDocumentType"
    ></base-row-detail>
    <!-- <b-form-group
      :label="$t('tracking.cargo.clientDocumentType')"
      label-for="ClientDocumentType"
    >
      <b-form-select
        id="ClientDocumentType"
        :options="optionsDocumentType"
        v-model="model.clientDocumentType"
        :disabled="readonlyMain"
      ></b-form-select>
      <span class="text-danger" v-if="modelstate['ClientDocumentType']">
        {{ modelstate["ClientDocumentType"][0] }}
      </span>
    </b-form-group> -->

    <!-- ClientPersonalDocument -->
    <base-row-detail
      v-if="model.clientDocumentType == 'CPF'"
      :label="$t('tracking.cargo.clientPersonalDocument')"
      :value="this.model.clientPersonalDocument"
    ></base-row-detail>
    <!-- <b-form-group
      v-if="model.clientDocumentType == 'CPF'"
      :label="$t('tracking.cargo.clientPersonalDocument')"
      label-for="ClientPersonalDocument"
    >
      <b-form-input
        id="ClientPersonalDocument"
        type="text"
        :placeholder="$t('tracking.cargo.clientPersonalDocument')"
        v-model="model.clientPersonalDocument"
        v-mask="'999.999.999-99'"
        :readonly="readonlyMain"
      />
      <span class="text-danger" v-if="modelstate['ClientPersonalDocument']">
        {{ modelstate["ClientPersonalDocument"][0] }}
      </span>
    </b-form-group> -->

    <!-- ClientCompanyDocument -->
    <base-row-detail
      v-if="model.clientDocumentType == 'CNPJ'"
      :label="$t('tracking.cargo.clientCompanyDocument')"
      :value="this.model.clientCompanyDocument"
    ></base-row-detail>
    <!-- <b-form-group
      v-if="model.clientDocumentType == 'CNPJ'"
      :label="$t('tracking.cargo.clientCompanyDocument')"
      label-for="ClientCompanyDocument"
    >
      <b-form-input
        id="ClientCompanyDocument"
        type="text"
        :placeholder="$t('tracking.cargo.clientCompanyDocument')"
        v-model="model.clientCompanyDocument"
        v-mask="'99.999.999/9999-99'"
        :readonly="readonlyMain"
      />
      <span class="text-danger" v-if="modelstate['ClientCompanyDocument']">
        {{ modelstate["ClientCompanyDocument"][0] }}
      </span>
    </b-form-group> -->

    <!-- ClientName -->

    <base-row-detail
      :label="$t('tracking.cargo.clientName')"
      :value="this.model.clientName"
    ></base-row-detail>

    <!-- dateDeliveryForecast -->
    <!-- ivan 20220725
    <base-row-detail
      v-if="this.getDatetimeDeliveryForecast"
      :label="'Entrega desejada'"
      :value="`${this.getDatetimeDeliveryForecast}`"
    ></base-row-detail> -->
    <!-- <base-row-detail
      v-if="this.model.dateDeliveryForecast"
      :label="'$t('tracking.cargo.dateDeliveryForecast')'"
      :value="`${this.model.dateDeliveryForecast}`"
    ></base-row-detail>
    <base-row-detail
      v-if="this.model.hourDeliveryForecast"
      :label="$t('tracking.cargo.timeDeliveryForecast')"
      :value="`${this.model.hourDeliveryForecast}`"
    ></base-row-detail> -->

    <!-- <b-form-group
      :label="$t('tracking.cargo.clientName')"
      label-for="ClientName"
    >
      <b-form-input
        id="ClientName"
        type="text"
        :placeholder="$t('tracking.cargo.clientName')"
        v-model="model.clientName"
        :readonly="readonlyMain"
      />
      <span class="text-danger" v-if="modelstate['ClientName']">
        {{ modelstate["ClientName"][0] }}
      </span>
    </b-form-group> -->

    <!-- Origin -->
    <base-row-detail
      :label="$t('tracking.cargo.origin')"
      :value="`${this.model.originCityName} - ${this.model.originStateAbrev}`"
    ></base-row-detail>

    <!-- OriginStateId -->
    <!-- <base-row-detail
      :label="$t('tracking.cargo.originState')"
      :value="this.model.originStateAbrev"
    ></base-row-detail> -->
    <!-- <b-form-group
      :label="$t('tracking.cargo.originState')"
      label-for="OriginStateId"
    >
      <b-form-select
        id="OriginStateId"
        :options="optionsState"
        v-model="model.originStateId"
        :disabled="readonlyMain"
      >
      </b-form-select>
      <span class="text-danger" v-if="modelstate['OriginStateId']">
        {{ modelstate["OriginStateId"][0] }}
      </span>
    </b-form-group> -->

    <!-- OriginCityId -->
    <!-- <base-row-detail
      :label="$t('tracking.cargo.originCity')"
      :value="this.model.originCityName"
    ></base-row-detail> -->
    <!-- <b-form-group
      :label="$t('tracking.cargo.originCity')"
      label-for="OriginCityId"
    >
      <city-dropdown
        id="OriginCityId"
        :readonly="readonlyMain"
        :state-id="parseInt(model.originStateId)"
        :city-id="model.originCityId"
        :changeData.sync="model.originCityId"
      >
      </city-dropdown>
      <span class="text-danger" v-if="modelstate['OriginCityId']">
        {{ modelstate["OriginCityId"][0] }}
      </span>
    </b-form-group> -->

    <!-- Destination -->
    <base-row-detail
      :label="$t('tracking.cargo.destination')"
      :value="`${this.model.destinationCityName} - ${this.model.destinationStateAbrev}`"
    ></base-row-detail>

    <!-- driver -->
    <!-- isStatusOpened -->
    <!-- isStatusNonAttendance -->
    <div v-if="model.statusNew != 3">
      <base-row-detail
        v-if="this.model.driverPersonalDocument"
        :label="$t('tracking.cargo.driverPersonalDocument')"
        :value="`${this.model.driverPersonalDocument}`"
      ></base-row-detail>
      <base-row-detail
        v-if="this.model.driver"
        :label="$t('tracking.cargo.driver')"
        :value="`${this.model.driver}`"
      ></base-row-detail>
      <base-row-detail
        v-if="this.model.driverPersonalDocument"
        :label="$t('tracking.cargo.cellphone')"
        :value="`${this.model.cellphone}`"
      ></base-row-detail>
      <base-row-detail
        v-if="this.model.vehiclePlate"
        :label="$t('tracking.cargo.vehiclePlate')"
        :value="`${this.model.vehiclePlate}`"
      ></base-row-detail>
    </div>
    <!-- transportNumber -->
    <base-row-detail
      v-if="this.model.transportNumber"
      :label="$t('tracking.cargo.transportNumber')"
      :value="`${this.model.transportNumber}`"
    ></base-row-detail>

    <!-- additionalInformation -->
    <base-row-detail
      v-if="
        model.additionalInformation && (model.status == 2 || model.status == 7)
      "
      :label="$t('tracking.cargo.additionalInformation')"
      :value="`${this.model.additionalInformation}`"
    ></base-row-detail>

    <!-- DateAttendance -->
    <!-- ivan 20220725
    <base-row-detail
      v-if="this.getDatetimeAttandance"
      :label="'Atendimento/coleta'"
      :value="`${this.getDatetimeAttandance}`"
    ></base-row-detail> -->

    <!-- DisapprovedDescriptionSolution -->
    <div>
      <base-row-detail
        v-if="isStatusInTraffic == true"
        :label="$t('tracking.cargo.disapprovedDescriptionSolution')"
        :value="`${this.model.disapprovedDescriptionSolution}`"
      ></base-row-detail>
    </div>

    <!-- DisapprovedDescription -->
    <div v-if="model.status == 14">
      <base-row-detail
        :label="$t('tracking.cargo.disapprovedReason')"
        :value="`${model.disapprovedReasonDisplayName}`"
      ></base-row-detail>
      <base-row-detail
        :label="$t('tracking.cargo.disapprovedDescription')"
        :value="`${model.disapprovedDescription}`"
      ></base-row-detail>
    </div>
    <div v-if="model.status == 15">
      <div v-if="cargoPath != null">
        <!-- OriginState -->
        <base-row-detail
          :label="$t('tracking.cargo.path.originState')"
          :value="`${cargoPath.originStateAbrev}`"
        ></base-row-detail>
        <!-- Origin City -->
        <base-row-detail
          :label="$t('tracking.cargo.path.originCity')"
          :value="`${cargoPath.originCityName}`"
        ></base-row-detail>
        <!-- Destination State -->
        <base-row-detail
          :label="$t('tracking.cargo.path.destinationState')"
          :value="`${cargoPath.destinationStateAbrev}`"
        ></base-row-detail>
        <!-- Destination City -->
        <base-row-detail
          :label="$t('tracking.cargo.path.destinationCity')"
          :value="`${cargoPath.destinationCityName}`"
        ></base-row-detail>
        <!-- Value Freight -->
        <base-row-detail
          :label="$t('tracking.cargo.path.valueFreight')"
          :value="`${cargoPath.freightCost}`"
        ></base-row-detail>
      </div>
      <!-- <div v-for="path in model.cargoPath" :key="path.id">
        <div v-if="path.id == cargoPath.id">
          <! -- OriginState -- >
          <base-row-detail
            :label="$t('tracking.cargo.path.originState')"
            :value="`${path.originStateAbrev}`"
          ></base-row-detail>
          <! -- Origin City -- >
          <base-row-detail
            :label="$t('tracking.cargo.path.originCity')"
            :value="`${path.originCityName}`"
          ></base-row-detail>
          <! -- Destination State -- >
          <base-row-detail
            :label="$t('tracking.cargo.path.destinationState')"
            :value="`${path.destinationStateAbrev}`"
          ></base-row-detail>
          <! -- Destination City -- >
          <base-row-detail
            :label="$t('tracking.cargo.path.destinationCity')"
            :value="`${path.destinationCityName}`"
          ></base-row-detail>
          <! -- Value Freight -- >
          <base-row-detail
            :label="$t('tracking.cargo.path.valueFreight')"
            :value="`${path.freightCost}`"
          ></base-row-detail>
        </div>
      </div> -->
    </div>
    <!-- Anexo da ocorrencias atenrior -->
    <div v-if="model.status != 15">
      <cargo-occurrences-attachments :model="model" :readonly="true">
      </cargo-occurrences-attachments>
    </div>
    <div class="mt-2">
      <!-- TransportNumber -->
      <!-- <b-form-group
        :label="$t('tracking.cargo.transportNumber')"
        label-for="transportNumber"
      >
        <b-form-input
          id="transportNumber"
          :placeholder="$t('tracking.cargo.transportNumber')"
          v-model="model.transportNumber"
          :readonly="readonly"
        />
        <span class="text-danger" v-if="modelstate['TransportNumber']">
          {{ modelstate["TransportNumber"][0] }}
        </span>
      </b-form-group> -->
      <b-row>
        <b-col sm="12" md="8">
          <div v-if="isStatusDelivered == false">
            <!-- Status Next -->
            <b-form-group
              :label="$t('tracking.cargo.statusNext')"
              label-for="Status"
            >
              <b-form-select
                id="Status"
                :options="optionsStatusNext"
                v-model="model.statusNew"
                :disabled="readonly"
              >
              </b-form-select>
              <span class="text-danger" v-if="modelstate['Status']">
                {{ modelstate["Status"][0] }}
              </span>
            </b-form-group>
          </div>
          <!-- CargoPaths -->
          <div v-if="model.status == 15">
            <!-- CargoPaths -->
            <div v-if="cargoPath != null">
              <cargo-crud-status-waiting-documents-paths
                :model="cargoPath"
                :readonly="readonly"
                :modelstate="modelstate"
              >
              </cargo-crud-status-waiting-documents-paths>
            </div>
          </div>

          <div v-if="isStatusNonAttendance">
            <cargo-crud-status-non-attendance
              :model="model"
              :modelstate="modelstate"
              :readonly="readonly"
            >
            </cargo-crud-status-non-attendance>
          </div>

          <div v-if="isStatusOpened"></div>

          <div v-if="isStatusSearchVehicle">
            <cargo-crud-status-opened
              :model="model"
              :modelstate="modelstate"
              :readonly="readonly"
            >
            </cargo-crud-status-opened>
          </div>

          <div v-if="isStatusChecklistLoading">
            <cargo-crud-status-search-vehicle
              :model="model"
              :modelstate="modelstate"
              :readonly="readonly"
            >
            </cargo-crud-status-search-vehicle>
          </div>
          <div v-if="isStatusScheduler">
            <cargo-crud-status-checklist-loading
              :model="model"
              :modelstate="modelstate"
              :readonly="readonly"
            >
            </cargo-crud-status-checklist-loading>
          </div>

          <div v-if="isStatusWaitingCollect">
            <cargo-crud-status-scheduler
              :model="model"
              :modelstate="modelstate"
              :readonly="readonly"
            >
            </cargo-crud-status-scheduler>
          </div>

          <div v-if="isStatusLoading">
            <cargo-crud-status-waiting-collect
              :model="model"
              :modelstate="modelstate"
              :readonly="readonly"
            >
            </cargo-crud-status-waiting-collect>
          </div>
          <div v-if="isStatusWaitingDocuments">
            <cargo-crud-status-loading
              v-if="model.cargoTypeId == 1"
              :model="model"
              :modelstate="modelstate"
              :readonly="readonly"
            >
            </cargo-crud-status-loading>
            <cargo-crud-status-search-vehicle
              v-else
              :model="model"
              :modelstate="modelstate"
              :readonly="readonly"
            >
            </cargo-crud-status-search-vehicle>
          </div>
          <div v-if="isDisapproved">
            <cargo-crud-status-disapproved
              :model="model"
              :modelstate="modelstate"
              :readonly="readonly"
            >
            </cargo-crud-status-disapproved>
          </div>
          <div v-if="isStatusInTraffic">
            <cargo-crud-status-waiting-documents
              :model="model"
              :modelstate="modelstate"
              :readonly="readonly"
            >
            </cargo-crud-status-waiting-documents>
          </div>
          <div v-if="isStatusWaitingUnload">
            <cargo-crud-status-in-traffic
              :model="model"
              :modelstate="modelstate"
              :readonly="readonly"
            >
            </cargo-crud-status-in-traffic>
          </div>

          <div v-if="isStatusUnloading">
            <cargo-crud-status-waiting-unload
              :model="model"
              :modelstate="modelstate"
              :readonly="readonly"
            >
            </cargo-crud-status-waiting-unload>
          </div>
          <!-- <div v-if="isWaitingDocumentsPaths">
            <cargo-crud-status-waiting-documents-paths
              :model="model"
              :modelstate="modelstate"
              :readonly="readonly"
            >
            </cargo-crud-status-waiting-documents-paths>
          </div> -->
          <div v-if="isStatusDelivered && this.model.status != 11">
            <cargo-crud-status-unloading
              :model="model"
              :modelstate="modelstate"
              :readonly="readonly"
            >
            </cargo-crud-status-unloading>
          </div>

          <div v-if="this.model.status == 11">
            <b-button class="mb-4" size="sm" @click.prevent="openImage()">
              <i class="tim-icons icon-camera-18 mb-1 mr-2"></i>
              Mostrar canhoto
            </b-button>
          </div>
          <fullscreen-sidebar ref="fullscreenSidebar">
            <template v-slot:content>
              <img :src="attachmentUrl" class="fullscreen-sidebar-img" />
            </template>
          </fullscreen-sidebar>
        </b-col>
      </b-row>
    </div>

    <!-- NonAttendanceDescription -->
    <!-- <div v-if="isStatusNonAttendance">
      <b-form-group
        label="Motivo do não atendimento"
        label-for="NonAttendanceDescription"
      >
        <b-form-textarea
          id="NonAttendanceDescription"
          placeholder="Motivo do não atendimento"
          v-model="model.nonAttendanceDescription"
          :readonly="readonly"
        />
        <span class="text-danger" v-if="modelstate['NonAttendanceDescription']">
          {{ modelstate["NonAttendanceDescription"][0] }}
        </span>
      </b-form-group>
    </div> -->
    <!-- <pre class="language-json"><code>{{ model }}</code></pre> -->
    <!-- <pre class="language-json"><code>{{ model.statusNew }}</code></pre> -->
    <!-- <div>{{ statusBase }}</div> -->
    <!-- <div>{{ model }}</div> -->
  </b-container>
</template>

<script>
import AwesomeMask from "awesome-mask";
import BaseErrorContainer from "../../base/BaseErrorContainer.vue";
import CargoCrudStatusChecklistLoading from "@/components_rms/tracking/cargo/status/CargoCrudStatusChecklistLoading.vue";
import CargoCrudStatusDelivered from "@/components_rms/tracking/cargo/status/CargoCrudStatusDelivered.vue";
import CargoCrudStatusInTraffic from "@/components_rms/tracking/cargo/status/CargoCrudStatusInTraffic.vue";
import CargoCrudStatusLoading from "@/components_rms/tracking/cargo/status/CargoCrudStatusLoading.vue";
import CargoCrudStatusOpened from "@/components_rms/tracking/cargo/status/CargoCrudStatusOpened.vue";
import CargoCrudStatusScheduler from "@/components_rms/tracking/cargo/status/CargoCrudStatusScheduler.vue";
import CargoCrudStatusSearchVehicle from "@/components_rms/tracking/cargo/status/CargoCrudStatusSearchVehicle.vue";
import CargoCrudStatusUnloading from "@/components_rms/tracking/cargo/status/CargoCrudStatusUnloading.vue";
import CargoCrudStatusWaitingCollect from "@/components_rms/tracking/cargo/status/CargoCrudStatusWaitingCollect.vue";
import CargoCrudStatusWaitingDocuments from "@/components_rms/tracking/cargo/status/CargoCrudStatusWaitingDocuments.vue";
import CargoCrudStatusWaitingUnload from "@/components_rms/tracking/cargo/status/CargoCrudStatusWaitingUnload.vue";
import CargoCrudStatusNonAttendance from "./status/CargoCrudStatusNonAttendance.vue";
import CargoOccurrencesAttachments from "./CargoOccurrencesAttachments.vue";
import BaseRowDetail from "../../base/BaseRowDetail.vue";
import FullscreenSidebar from "@/components_rms/FullscreenSidebar.vue";
import CargoCrudStatusDisapproved from "@/components_rms/tracking/cargo/status/CargoCrudStatusDisapproved.vue";
import CargoCrudStatusWaitingDocumentsPaths from "@/components_rms/tracking/cargo/status/CargoCrudStatusWaitingDocumentPath.vue";
export default {
  name: "CargoCrudData",
  directives: {
    mask: AwesomeMask,
  },
  props: {
    model: Object,
    modelstate: Object,
    readonly: Boolean,
  },
  components: {
    BaseErrorContainer,
    CityDropdown: () => import("@/components_rms/System/city/CityDropdown.vue"),
    CargoCrudStatusChecklistLoading,
    CargoCrudStatusDelivered,
    CargoCrudStatusInTraffic,
    CargoCrudStatusLoading,
    CargoCrudStatusNonAttendance,
    CargoCrudStatusOpened,
    CargoCrudStatusScheduler,
    CargoCrudStatusSearchVehicle,
    CargoCrudStatusUnloading,
    CargoCrudStatusWaitingCollect,
    CargoCrudStatusWaitingDocuments,
    CargoCrudStatusWaitingUnload,
    CargoOccurrencesAttachments,
    BaseRowDetail,
    FullscreenSidebar,
    CargoCrudStatusDisapproved,
    CargoCrudStatusWaitingDocumentsPaths,
  },
  data() {
    return {
      attachmentUrl: "",
      optionsBoolean: [
        { value: true, text: "Sim" },
        { value: false, text: "Não" },
      ],
      optionsDocumentType: ["CPF", "CNPJ"],
      optionsState: [{ value: null, text: "Carregando cidades" }],
      optionsStatus: [
        { value: 1, text: "Em aberto" },
        { value: 12, text: "Não atendimento" },
        { value: 2, text: "Procurando veiculo" },
        { value: 3, text: "Checklist de carregamento" },
        { value: 4, text: "Agendado" },
        { value: 5, text: "Aguardando coleta" },
        { value: 6, text: "Carregando" },
        { value: 7, text: "Aguardando documentos" },
        { value: 8, text: "Em transito" },
        { value: 9, text: "Aguardando descarga" },
        { value: 10, text: "Descarregando" },
        { value: 11, text: "Entregue" },
        { value: 12, text: "Aguardando documentos - Trajetos" },
        // { value: 13, text: "Expirado" },
      ],
      optionsStatusNext: [
        { value: 1, text: "Em aberto" },
        { value: 12, text: "Não atendimento" },
        { value: 2, text: "Procurando veiculo" },
        { value: 3, text: "Checklist de carregamento" },
        { value: 4, text: "Agendado" },
        { value: 5, text: "Aguardando coleta" },
        { value: 6, text: "Carregando" },
        { value: 7, text: "Aguardando documentos" },
        { value: 8, text: "Em transito" },
        { value: 9, text: "Aguardando descarga" },
        { value: 10, text: "Descarregando" },
        { value: 11, text: "Entregue" },
        { value: 12, text: "Aguardando documentos - Trajetos" },
        // { value: 13, text: "Expirado" },
      ],
      optionsVehicleType: [
        { value: null, text: "Carregando tipos de veículo" },
      ],
      readonlyMain: true,
      cargoPath: null,
    };
  },
  created() {
    this.loadStates();
    this.loadVehicleTypes();
    this.refreshModel();
    this.cargoPath = this.getCurrentPath();
    this.$forceUpdate();
  },
  computed: {
    cargoTypeDescription() {
      if (this.model == null) return "";
      if (this.model.cargoTypeId == 2) return "Subcontrato";
      return "Contrato";
    },
    isStatusOpened() {
      // { value: 2, text: "Procurando veiculo" },
      if (this.model.statusNew == 1) {
        return true;
      }
      return false;
    },
    isStatusSearchVehicle() {
      // { value: 2, text: "Procurando veiculo" },
      if (this.model.statusNew == 2) {
        return true;
      }
      //   if (this.isStatusChecklistLoading) {
      //     return true;
      //   }
      return false;
    },
    isStatusChecklistLoading() {
      if (this.model.statusNew == 3) {
        return true;
      }
      return false;
    },
    isStatusScheduler() {
      if (this.model.statusNew == 4) {
        return true;
      }
      return false;
    },
    isStatusWaitingCollect() {
      // { value: 5, text: "Aguardando coleta" },
      if (this.model.statusNew == 5) {
        return true;
      }
      //   if (this.isStatusLoading) {
      //     return true;
      //   }
      return false;
    },
    isStatusLoading() {
      // { value: 6, text: "Carregando" },
      if (this.model.statusNew == 6) {
        return true;
      }
      //   if (this.isStatusInTraffic) {
      //     return true;
      //   }
      return false;
    },
    isStatusWaitingDocuments() {
      if (this.model.statusNew == 7) {
        return true;
      }
      // if (this.isStatusInTraffic) {
      //   return true;
      // }
      return false;
    },
    isStatusInTraffic() {
      // { value: 8, text: "Em transito" },
      if (this.model.statusNew == 8) {
        return true;
      }
      //   if (this.isStatusWaitingUnload) {
      //     return true;
      //   }
      return false;
    },
    isStatusWaitingUnload() {
      // { value: 9, text: "Aguardando descarga" },
      if (this.model.statusNew == 9) {
        return true;
      }
      //   if (this.isStatusUnloading) {
      //     return true;
      //   }
      return false;
    },
    isStatusUnloading() {
      // { value: 10, text: "Descarregando" },
      if (this.model.statusNew == 10) {
        return true;
      }
      //   if (this.isStatusDelivered) {
      //     return true;
      //   }
      return false;
    },
    isStatusDelivered() {
      // { value: 11, text: "Entregue" }
      if (this.model.statusNew == 11) {
        return true;
      }
      return false;
    },
    isStatusNonAttendance() {
      if (this.model.statusNew == 12) {
        return true;
      }
      return false;
    },
    isDisapproved() {
      if (this.model.statusNew == 14) {
        return true;
      }
      return false;
    },
    isWaitingDocumentsPaths() {
      if (this.model.statusNew == 15) {
        return true;
      }
      return false;
    },
  },
  methods: {
    dataFormat() {
      // if (this.model.dateAttendance == "") this.model.dateAttendance = null;

      if (!this.model.dateAttendance)
        if (this.model.dateAttendance == "") this.model.dateAttendance = null;
      // if (this.model.dateDeliveryForecast == "")
      //   this.model.dateDeliveryForecast = null;
      if (!this.model.dateDeliveryForecast)
        if (this.model.dateDeliveryForecast == "")
          this.model.dateDeliveryForecast = null;

      if (this.model.statusNew == "") this.model.statusNew = 1;
      this.model.statusNew = parseInt(this.model.statusNew);

      if (this.model.destinationCityId == "")
        this.model.destinationCityId = null;
      this.model.destinationCityId = parseInt(this.model.destinationCityId);

      if (this.model.destinationStateId == "")
        this.model.destinationStateId = null;
      this.model.destinationStateId = parseInt(this.model.destinationStateId);

      if (this.model.originCityId == "") this.model.originCityId = null;
      this.model.originCityId = parseInt(this.model.originCityId);

      if (this.model.originStateId == "") this.model.originStateId = null;
      this.model.originStateId = parseInt(this.model.originStateId);

      if (this.model.vehicleTypeId == "") this.model.vehicleTypeId = null;
      this.model.vehicleTypeId = parseInt(this.model.vehicleTypeId);

      // isStatusChecklistLoading
      if (!this.model.checklistId)
        if (this.model.checklistId != "")
          this.model.checklistId = parseInt(this.model.checklistId);

      // isStatusWaitingCollect
      if (!this.model.loadingStartDate)
        if (this.model.loadingStartDate == "")
          this.model.loadingStartDate = null;

      // isStatusWaitingDocuments
      if (!this.model.loadingEndDate)
        if (this.model.loadingEndDate == "") this.model.loadingEndDate = null;

      // isStatusInTraffic
      if (!this.model.transportStartDate)
        if (this.model.transportStartDate == "")
          this.model.transportStartDate = null;

      // isStatusWaitingUnload
      if (!this.model.arrivalDateAtDestination)
        if (this.model.arrivalDateAtDestination == "")
          this.model.arrivalDateAtDestination = null;

      // isStatusUnloading
      if (!this.model.unloadStartDate)
        if (this.model.unloadStartDate == "") this.model.unloadStartDate = null;

      // isStatusDelivered
      if (!this.model.deliveryDate)
        if (this.model.deliveryDate == "") this.model.deliveryDate = null;
    },
    dateToString(date) {
      if (date) {
        if (date != null && date != "") {
          return date.split("T")[0];
        }
      }
      return null;
    },
    dateHourToString(dateString, hourString) {
      if (dateString) {
        let date = new Date(`${dateString}T${hourString}:00`);
        if (hourString) {
          if (hourString != "00:00") {
            return date.toLocaleString();
          }
        }
        return date.toLocaleDateString();
      }
      return "";
    },
    async loadStates() {
      this.$api
        .get("/state/getDropdownOptions")
        .then((response) => {
          this.optionsState = response.data;
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.alert.error = error.message;
            this.$refs.danger.show();
          }
        });
    },
    loadOptionsStatusNext() {
      switch (this.model.status) {
        case 1:
          this.model.statusNew = 2;
          this.optionsStatusNext = [
            { value: 2, text: "Procurando veiculo" },
            { value: 12, text: "Não atendimento" },
          ];
          break;
        case 2:
          if (this.model.cargoTypeId == 1) {
            // Contrato
            this.model.statusNew = 3;
            this.optionsStatusNext = [
              { value: 3, text: "Checklist de carregamento" },
              { value: 12, text: "Não atendimento" },
            ];
          } else {
            // Subcontrato
            this.model.statusNew = 7;
            this.optionsStatusNext = [
              { value: 7, text: "Aguardando documentos" },
              { value: 12, text: "Não atendimento" },
            ];
          }
          break;
        case 3:
          this.model.statusNew = 4;
          this.optionsStatusNext = [{ value: 4, text: "Agendado" }];
          break;
        case 4:
          this.model.statusNew = 5;
          this.optionsStatusNext = [{ value: 5, text: "Aguardando coleta" }];
          break;
        case 5:
          this.model.statusNew = 6;
          this.optionsStatusNext = [{ value: 6, text: "Carregando" }];
          break;
        case 6:
          this.model.statusNew = 7;
          this.optionsStatusNext = [
            { value: 7, text: "Aguardando documentos" },
          ];
          break;
        case 7:
          this.model.statusNew = 8;
          this.optionsStatusNext = [
            { value: 8, text: "Em transito" },
            { value: 14, text: "Reprovado" },
          ];
          break;
        case 8:
          this.model.statusNew = 9;
          this.optionsStatusNext = [{ value: 9, text: "Aguardando descarga" }];
          break;
        case 9:
          this.model.statusNew = 10;
          this.optionsStatusNext = [{ value: 10, text: "Descarregando" }];
          break;
        case 10:
          this.model.statusNew = 11;
          this.optionsStatusNext = [{ value: 11, text: "Entregue" }];
          break;
        case 12:
          this.model.statusNew = 12;
          this.optionsStatusNext = [{ value: 12, text: "Não atendimento" }];
          break;
        case 13:
          this.model.statusNew = 2;
          this.optionsStatusNext = [
            { value: 2, text: "Procurando veiculo" },
            { value: 12, text: "Não atendimento" },
          ];
          break;
        case 14:
          this.model.statusNew = 7;
          this.optionsStatusNext = [
            { value: 7, text: "Aguardando documentos" },
          ];
          break;
        case 15:
          this.model.statusNew = 8;
          this.optionsStatusNext = [{ value: 8, text: "Em transito" }];
          break;
        default:
          this.model.statusNew = this.model.status;
          break;
      }
    },
    async loadVehicleTypes() {
      this.$api
        .get("/vehicleType/dropdownOptions")
        .then((response) => {
          // console.log('vehicletype');
          // console.log(response);
          // console.log(response.data);
          this.optionsVehicleType = response.data;
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.alert.error = error.message;
            this.$refs.danger.show();
          }
        });
    },
    async loadImg() {
      if (this.model) {
        this.$api
          .request({
            url: `${this.$store.state.urlTracking}/v1/cargo/attachment/${this.model.cargoId}/11`,
            method: "GET",
            responseType: "arraybuffer", //important
          })
          .then((response) => {
            this.attachmentUrl = window.URL.createObjectURL(
              new Blob([response.data], {
                type: response.headers["content-type"],
              })
            );
          })
          .catch((error) => {
            console.log(error);
            console.log(error.response.data.errors);
            if (error.response.status == 400) {
              console.log(error.response.data.errors);
            }
          });
      }
      return "";
    },
    openImage() {
      this.attachmentUrl = "";
      this.loadImg();
      this.$refs.fullscreenSidebar.open();
    },
    async refreshModel() {
      if (this.model) {
        // console.log(`CargoCrudKanban - model - watch`);
        // console.log(`this.model.dateAttendance: ${this.model.dateAttendance}`);

        this.loadOptionsStatusNext();

        this.model.dateAttendance = this.dateToString(
          this.model.dateAttendance
        );
        this.model.dateDeliveryForecast = this.dateToString(
          this.model.dateDeliveryForecast
        );
        this.model.dateDeliveryForecast = this.dateToString(
          this.model.dateDeliveryForecast
        );

        // isStatusWaitingCollect
        this.model.loadingStartDate = this.dateToString(
          this.model.loadingStartDate
        );

        // isStatusWaitingDocuments
        this.model.loadingEndDate = this.dateToString(
          this.model.loadingEndDate
        );

        // isStatusInTraffic
        this.model.transportStartDate = this.dateToString(
          this.model.transportStartDate
        );

        // isStatusWaitingUnload
        this.model.arrivalDateAtDestination = this.dateToString(
          this.model.arrivalDateAtDestination
        );

        // isStatusUnloading
        this.model.unloadStartDate = this.dateToString(
          this.model.unloadStartDate
        );

        // isStatusDelivered
        this.model.deliveryDate = this.dateToString(this.model.deliveryDate);
        // if (this.model.dateAttendance != null) this.model.dateDeliveryForecast = this.model.dateDeliveryForecast.split("T")[0];
        // if (this.model.dateAttendance != null) this.model.dateAttendance = this.model.dateAttendance.split("T")[0];
      }
    },
    getSortedPathList(arrayObject) {
      if (arrayObject) {
        if (arrayObject.length > 0) {
          return arrayObject
            .filter((x) => x.active == true)
            .sort((a1, a2) => a1.sequenceNumber - a2.sequenceNumber);
        }
      }
      return arrayObject;
    },
    getCurrentPath() {
      if (!this.model) return null;
      if (this.model == null) return null;
      if (!this.model.cargoPath) return null;
      if (this.model.cargoPath == null) return null;

      let paths = this.getSortedPathList(this.model.cargoPath);
      for (let path of paths) {
        if (path.active && !path.delivered) {
          return path;
        }
      }

      return null;

      // this.$api
      //   .get("/v1/cargoPath/getByCargoId/" + this.model.cargoId)
      //   .then((response) => {
      //     // console.log("cargoPath")
      //     // console.log(response);
      //     this.cargoPath = response.data;
      //     this.$forceUpdate();
      //   })
      //   .catch((error) => {
      //     if (error.response.status == 401) {
      //       this.$store.dispatch("logout").then(() => {
      //         this.$router.push("/login");
      //       });
      //     } else {
      //       this.alert.error = error.message;
      //       this.$refs.danger.show();
      //     }
      //   });
    },
  },
  watch: {
    model() {
      this.refreshModel();
      this.cargoPath = this.getCurrentPath();
      this.$forceUpdate();
    },
  },
};
</script>

<style scoped>
.fullscreen-sidebar-img {
  /* zoom: 2; increase if you have very small images */
  margin: auto;
  height: auto;
  max-height: 200%;
  width: auto;
  max-width: 200%;
  /* padding-left: 20%; */
}
</style>